import type { SuburbInput } from "@repo/adapter-core";
import type { SoldOnlyAdapterConfig } from "../shared/sold-only.ts";

export function buildSearchUrl(suburb: SuburbInput, _config: SoldOnlyAdapterConfig): string {
  return `https://www.jelliscraig.com.au/sold/list?suburb=${encodeURIComponent(suburb.locality)},+${suburb.postcode}&surrounding=2000`;
}
